import { useNavigate, useRouteError } from "react-router-dom";

const ErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4 p-4 bg-primary-500">
      <img
        src="/buddybox-logo-dark.svg"
        className="w-24 mb-8"
        alt="Logo da Buddybox"
      />

      <h1 className="text-5xl font-bold text-white">
        {error.status === 404 ? "Página não encontrada" : "Ocorreu um erro"}
      </h1>

      <p className="text-white text-xl max-w-md text-center">
        {error.status === 404
          ? "A página que você está procurando não existe ou foi movida."
          : "Desculpe, algo deu errado. Por favor, tente novamente mais tarde."}
      </p>

      <button
        onClick={handleGoBack}
        className="px-4 py-2 bg-white text-primary-500 rounded hover:bg-gray-200 transition"
      >
        Voltar
      </button>
    </div>
  );
};

export default ErrorPage;
